import { render, staticRenderFns } from "./BtnAddToShow.vue?vue&type=template&id=dc34f6ee&"
import script from "./BtnAddToShow.vue?vue&type=script&lang=js&"
export * from "./BtnAddToShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports